import script from "./WomuMainEN.vue?vue&type=script&setup=true&name=WomuMain&lang=js"
export * from "./WomuMainEN.vue?vue&type=script&setup=true&name=WomuMain&lang=js"

const __exports__ = script;

export default __exports__